import { useNavigate, useLocation } from 'react-router-dom'
import { Icon } from '../components/Icon'
import styles from './Success.module.css'

interface LocationState {
  channelName?: string
  nudgeEnabled?: boolean
  weeklyDigestEnabled?: boolean
}

export function Success() {
  const navigate = useNavigate()
  const { state } = useLocation()
  const { channelName = 'your channel', nudgeEnabled, weeklyDigestEnabled } = (state as LocationState) ?? {}

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.icon}>
          <Icon name="check_circle" size={36} />
        </div>
        <h1 className={styles.title}>You're all set</h1>
        <p className={styles.sub}>
          Review Ops is now active in <strong>{channelName}</strong>. Review updates and nudge reminders are enabled.
        </p>
        <div className={styles.whatNext}>
          <div className={styles.sectionLabel}>What happens next</div>
          <div className={styles.item}>
            <Icon name="check_circle" size={18} className={styles.itemIcon} />
            Bot will post in <strong>{channelName}</strong> when a new PR needs review
          </div>
          {nudgeEnabled && (
            <div className={styles.item}>
              <Icon name="check_circle" size={18} className={styles.itemIcon} />
              Nudges sent when PRs go stale
            </div>
          )}
          {weeklyDigestEnabled && (
            <div className={styles.item}>
              <Icon name="check_circle" size={18} className={styles.itemIcon} />
              Weekly digest every <strong>Monday morning</strong>
            </div>
          )}
        </div>
        <div className={styles.actions}>
          <button className="btn btn-outline" onClick={() => navigate('/')}>
            <Icon name="settings" size="sm" /> Configure settings
          </button>
          <button className="btn btn-primary" onClick={() => navigate('/')}>
            <Icon name="dashboard" size="sm" /> View all channels
          </button>
        </div>
      </div>
    </div>
  )
}
